module.exports = __webpack_public_path__ + "img/1866a31.jpg";